import { routesWithoutCustomerAndOhCaseIds as taskActionSubRoutes } from "../../task/taskActions/routes";

import { detailRoutes } from "./detailRoutes";
import { AppState } from "./model";
import { ohCaseSelector } from "./selectors";

const detailRoute = () => ({
    "/:ohCaseId": {
        title: (state: AppState) => ohCaseSelector(state) ? `Case ${ohCaseSelector(state).caseId}` : "Case",
        "/edit": {
            title: "Edit",
        },
        "/firstTask": {
            title: "Initial Task"
        },
        ...taskActionSubRoutes,
        ...detailRoutes,
        ...createImmunisationCase,
        ...createLinkedPhysiotherapyMgrReferralCase,
        ...createLinkedPhysiotherapySelfReferralCase,
        ...createMHPCase
    },
    ...createImmunisationCase,
    ...createPpqCase,
    ...createReferralCase,
    ...createGenericCase,
    ...createPhysiotherapyReferralCase,
    ...createPhysiotherapyMgrReferralCase,
    ...createPhysiotherapySelfReferralCase,
    ...createMHPCase
});

const createImmunisationCase = {
    "/createImmunisationCase": {
        title: "Create Immunisation Case",
    }
};

const createLinkedPhysiotherapyMgrReferralCase = {
    "/createPhysiotherapyMgrReferralCase/:linkedOhCaseId": {
        title: "Create Physiotherapy Manager Referral Case"
    }
};

const createLinkedPhysiotherapySelfReferralCase = {
    "/createPhysiotherapySelfReferralCase/:linkedOhCaseId": {
        title: "Create Physiotherapy Self Referral Case"
    }
};

const createPpqCase = {
    "/createPpqCase": {
        title: "Create PPQ Case"
    }
};

const createReferralCase = {
    "/createReferralCase": {
        title: "Create Referral Case"
    }
};

const createPhysiotherapyReferralCase = {
    "/createPhysiotherapyReferralCase": {
        title: "Create Physiotherapy Referral Case"
    }
};

const createPhysiotherapyMgrReferralCase = {
    "/createPhysiotherapyMgrReferralCase": {
        title: "Create Physiotherapy Manager Referral Case"
    }
};

const createPhysiotherapySelfReferralCase = {
    "/createPhysiotherapySelfReferralCase": {
        title: "Create Physiotherapy Self Referral Case"
    }
};

const createGenericCase = {
    "/createGenericCase": {
        title: "Create Generic Case"
    }
};

const createMHPCase = {
    "/createMHPCase": {
        title: "Create MHP Treatment case"
    }
};

export const routes = {
    "/ohCases": {
        title: "OhCases",
        ...detailRoute(),
        "/createHealthSurveillance": {
            title: "Create Health Surveillance/Fit for Work Case"
        }
    }
};

